import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Table, Loader} from 'semantic-ui-react';
import {shortDate} from '../../../../common/constants/datesFormat';

class Reservations extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  getTotal() {
    const {reservations} = this.props;

    return reservations.reduce((total, reservation) => {
      return total + (reservation.reserveQuantity || 0);
    }, 0);
  }

  renderReservationsDetail() {
    const {reservations} = this.props;
  
    return reservations.map((order, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='left'>{order.orderCode}</Table.Cell>
          <Table.Cell textAlign='center'>{order.bill}</Table.Cell>
          <Table.Cell textAlign='center'>
            {order.user ? order.user.toUpperCase() : null}
          </Table.Cell>
          <Table.Cell textAlign='right'>{order.reserveQuantity}</Table.Cell>
          <Table.Cell textAlign='center'>
            {order.arrivalDate ? moment(order.arrivalDate).format(shortDate) : null}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Loader active inline='centered'>Consultando...</Loader>
      );
    }

    return (
      <div className='table-scroll-container'>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan='5'>Pedidos Reservados</Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell textAlign='center' className='fixed'>Pedido C.</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='fixed'>Pedido O.</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='fixed'>Usuario</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='fixed'>Cantidad</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='fixed'>Fecha Llegada</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.renderReservationsDetail()}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan='5' textAlign='center'>
                Total: {this.getTotal()}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partModals.loadingReservations,
    'reservations': state.partModals.reservations,
  };
};

export default connect(mapStateToProps)(Reservations);
